/*
    作業者を選択するリスト
*/
import React from "react";
import ReactSelect, { SingleValue, ActionMeta } from "react-select";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { PlantTeamMember } from "../../redux/memberSlice";
import { GetWorkStatus } from "../../models/GetWorkStatus";
import { MemberSelectWithWorkStatusLabel } from "./MemberSelectWithWorkStatusLabel";

export type ProcCodeSelectProp = {
  // ラベル
  label: string;
  // 作業者
  selectMenberId: string;
  // 工場コード
  plantCode: string;
  // 加工コード==所属コード（チーム）
  teamCode: string;
  // 作業状況
  workStatuses: GetWorkStatus[] | null;
  // 作業者が選択された場合のイベント処理
  handleMemberChange: (
    selectedOption: SingleValue<any>,
    actionMeta: ActionMeta<any>
  ) => void;
};

export const MemberSelectWithWorkStatus: React.FC<ProcCodeSelectProp> = ({
  label,
  selectMenberId,
  plantCode,
  teamCode,
  workStatuses,
  handleMemberChange,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "member-select-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  const plantTeamMember: PlantTeamMember[] = useSelector(
    (state: RootState) => state.member.plant_team_member
  );
  // const orgMembers :Member[] = useSelector((state:RootState) => state.member.original_member);

  const teams = plantTeamMember.find((d) => d.plant_code === plantCode)?.teams;
  const members = teams?.find((d) => d.proc_code === teamCode)?.members;

  const defaltMemberList = [
    {
      value: "",
      label: (
        <MemberSelectWithWorkStatusLabel
          workerName="-"
          workerMemberId=""
          workStatuses={null}
        />
      ),
    },
  ];
  const filteredMemberList =
    members?.map(({ member_id, name }) => ({
      value: member_id,
      label: (
        <MemberSelectWithWorkStatusLabel
          workerName={name}
          workerMemberId={member_id}
          workStatuses={workStatuses}
        />
      ),
    })) || [];
  const options = [...defaltMemberList, ...filteredMemberList];

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <ReactSelect
        inputId={id}
        value={options.find((item) => item.value === selectMenberId)}
        options={options}
        onChange={handleMemberChange}
        isSearchable={false}
        noOptionsMessage={() => ""}
        placeholder=""
        className="react-select-container"
        classNamePrefix="react-select"
      />
    </>
  );
};
